import { FC } from 'react';

type Props = {
	className?: string;
};

const Archive_02_Icon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6.00065 17.201H14.0019C15.8878 17.201 16.8307 17.201 17.4167 16.6152C18.0025 16.0292 18.0025 15.0863 18.0025 13.2004C18.0025 11.3145 18.0025 10.3715 17.4167 9.78556C16.8307 9.19971 15.8878 9.19971 14.0019 9.19971H6.00065C4.11476 9.19971 3.17182 9.19971 2.58594 9.78556C2.00006 10.3714 2.00004 11.3144 2 13.2003C1.99996 15.0863 1.99994 16.0292 2.58583 16.6151C3.17171 17.201 4.1147 17.201 6.00065 17.201Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M3.59766 9.20003C3.5977 8.07967 3.59772 7.51949 3.8158 7.09157C4.00756 6.71527 4.31352 6.40932 4.68983 6.21757C5.11775 5.99951 5.67794 5.99951 6.7983 5.99951H13.1992C14.3195 5.99951 14.8796 5.99951 15.3076 6.21753C15.6839 6.40931 15.9899 6.71532 16.1817 7.09171C16.3997 7.5196 16.3997 8.07975 16.3997 9.20003'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.19922 5.99935C5.19925 4.87901 5.19927 4.31883 5.41733 3.89093C5.6091 3.5146 5.91507 3.20864 6.2914 3.01688C6.71931 2.79883 7.27949 2.79883 8.39982 2.79883H11.6003C12.7205 2.79883 13.2807 2.79883 13.7086 3.01685C14.085 3.20863 14.391 3.51464 14.5827 3.89102C14.8008 4.31891 14.8008 4.87906 14.8008 5.99935'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.2018 12.4004L12.9618 12.7204C12.4906 13.3486 12.255 13.6628 11.9171 13.8317C11.5792 14.0007 11.1866 14.0007 10.4014 14.0007H9.60124C8.81599 14.0007 8.42336 14.0007 8.08545 13.8317C7.74756 13.6628 7.51198 13.3486 7.04082 12.7204L6.80078 12.4004'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Archive_02_Icon;
